export default {
  SET_PROMOTER_ID({ commit }, payload) {
    commit('SET_PROMOTER_ID', payload);
  },
  SET_PROMOTER_NAME({ commit }, payload) {
    commit('SET_PROMOTER_NAME', payload);
  },
};
